import React from "react";
import { useNavigate } from "react-router-dom";

function Welcome() {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate("/login");
  };

  const handleSignUp = () => {
    navigate("/signup");
  };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="relative">
        <div className="h-screen overflow-y-auto p-4 pb-20 max-w-sm min-w-[375px] w-full bg-white">
          <div className="flex flex-col items-center justify-center h-full">
            <img
              className="mb-5 max-w-full h-auto align-top"
              src={`${process.env.PUBLIC_URL}/stock-market-analysis.jpg`}
              alt="logo"
            />
            <p 
              className="text-[20px] text-black mb-5 leading-[24px] font-bold font-lato"
            >
              Welcome to Finance
            </p>

            <p
              className="text-black text-base text-center mx-auto mb-6 w-[86%] font-lato"
            >
              Let's start your investing journey.
            </p>

            <div className="flex items-center justify-center m-[5px] p-[10px] w-full h-auto">
              <button
                type="button"
                className="w-full bg-[#536895] border border-[#536895] rounded-full text-white text-base font-semibold py-3"
                onClick={handleSignIn}
              >
                Sign In
              </button>
            </div>

            <div className="flex items-center justify-center m-[5px] p-[10px] w-full h-auto">
              <button
                type="button"
                className="w-full border border-[#536895] rounded-full text-[#536895] text-base font-semibold py-3"
                onClick={handleSignUp}
              >
                Sign Up
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;